import * as React from 'react';
import { Image, Text, TouchableOpacity, View } from 'react-native';
import { Colors, Fonts } from '../utils/Constants';

export default class NewButton extends React.PureComponent{
  render(){
    return (
    <TouchableOpacity onPress={this.props.action}>
      <View style={{marginBottom: this.props.marginBottom, flexDirection: 'row', alignItems: 'center', justifyContent: this.props.justifyContent ? this.props.justifyContent:'center', backgroundColor: this.props.color, width: this.props.width, height: this.props.height, borderRadius: this.props.border, borderWidth: this.props.borderWidth, borderColor: this.props.borderColor}}>
        {!!this.props.image &&
          <Image
            style={{width: this.props.height * 0.6, height: this.props.height * 0.6}}
            source={this.props.image}
          />
        }
        <Text style={{fontFamily: Fonts.mainFont, textAlign: 'center', fontSize: this.props.fontSize, color: this.props.textColor, fontWeight: this.props.font, padding: 12}}>{this.props.text}</Text>
      </View>
    </TouchableOpacity>
    );
  }
}